import { render, staticRenderFns } from "./FraudSignals.vue?vue&type=template&id=bcf06674&scoped=true&"
import script from "./FraudSignals.vue?vue&type=script&lang=js&"
export * from "./FraudSignals.vue?vue&type=script&lang=js&"
import style0 from "./FraudSignals.vue?vue&type=style&index=0&id=bcf06674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf06674",
  null
  
)

export default component.exports